// Per-tab persistence. `localStorage` is one bucket for the whole origin, so
// two Code tabs would otherwise share (and overwrite) the same windows/nav.
// `sessionStorage` is already isolated per tab and survives reload, so we:
//   1. Read this tab's session copy first.
//   2. On a brand-new tab, clone `localStorage` into the session (last snapshot).
//   3. Write both: the session is this tab, local is only the seed for the next
//      new tab. Existing tabs never re-read localStorage after the first load.

function getItem(store, key) {
  try {
    return store.getItem(key)
  } catch {
    return null
  }
}

function setItem(store, key, raw) {
  try {
    store.setItem(key, raw)
  } catch {
    /* ignore quota / privacy-mode errors */
  }
}

export function loadRaw(key) {
  if (typeof window === 'undefined' || !key) return null
  const session = getItem(window.sessionStorage, key)
  if (session != null) return session
  const shared = getItem(window.localStorage, key)
  if (shared == null) return null
  setItem(window.sessionStorage, key, shared)
  return shared
}

export function saveRaw(key, raw) {
  if (typeof window === 'undefined' || !key) return
  setItem(window.sessionStorage, key, raw)
  setItem(window.localStorage, key, raw)
}

export function loadJSON(key) {
  const raw = loadRaw(key)
  if (raw == null) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function saveJSON(key, value) {
  saveRaw(key, JSON.stringify(value))
}
